
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class TeacherOutstandingGrid extends Serenity.EntityGrid<TeacherOutstandingRow, any> {
        protected getColumnsKey() { return TeacherOutstandingColumns.columnsKey; }
        protected getDialogType() { return TeacherOutstandingDialog; }
        protected getIdProperty() { return TeacherOutstandingRow.idProperty; }
        protected getInsertPermission() { return TeacherOutstandingRow.insertPermission; }
        protected getLocalTextPrefix() { return TeacherOutstandingRow.localTextPrefix; }
        protected getService() { return TeacherOutstandingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: TeacherOutstandingService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            return buttons;

        }

        protected getQuickFilters() {
            var filter = super.getQuickFilters();
            if (Authorization.hasPermission("Users:Teacher") && !Authorization.hasPermission("Administration:Security")) {
                filter.splice(0, 2);
            }
            return filter;
        }
    }
}